
import { Box } from '@mui/system';
import Stack from '@mui/material/Stack';
import { Card, CardHeader, CardContent } from '@mui/material';

import { useBoolean } from 'src/hooks/use-boolean';
import { useOrgTenant } from 'src/hooks/auth/use-org-tenant';

import { useTranslate } from 'src/locales';
import { TaskLinkedEntityType } from 'src/services/tasks/tasks.types';
import PostCommentForm from 'src/layouts/common/threads/post-comment-form';
import PostCommentList from 'src/layouts/common/threads/post-comment-list';
import { useGetContactByIdQuery } from 'src/services/contacts/contacts.service';

import Iconify from 'src/components/iconify';

import LinkedTasks from 'src/sections/tasks/components/linked-tasks';




type Props = {
  contactId: string;
};

export const ContactDetailSection = ({ contactId }: Props) => {

  const showEditUserDialog = useBoolean();

  const { t } = useTranslate();

  const tenantType = useOrgTenant();

  const { data: contact, isFetching: isLoadingContact } = useGetContactByIdQuery(contactId, {
    skip: !contactId,
  });

  return (
    <Stack direction="column" spacing={2}>

      {
        contact?.thread?.id && (
          <Card>
            <CardHeader
              title={
                <Stack direction="row" gap={1} justifyContent="start" alignItems="center">
                  <Iconify icon="uil:notes" />
                  <Box>{t('contacts.detail.thread.title')}</Box>
                </Stack>
              }
            />
            <CardContent>
              <PostCommentForm thread_id={contact?.thread?.id} />
              <LinkedTasks entityType={TaskLinkedEntityType.CONTACT} entityId={contactId} />
              {/* JT1-1736: merged with the notes on the deals this contact is linked to */}
              <PostCommentList feed={{ type: 'contact', id: contactId }} />
            </CardContent>
          </Card>
        )
      }

    </Stack>
  )
};